import {useTranslation} from 'react-i18next'
import {EntitySearchSelect} from '@/components/entity-search-select'
import type {PaqueteDestino} from '@/lib/bateria-cola'

/** Combobox buscable: nunca un `<select>` nativo para entidades de cardinalidad N (R3). */
export function PaqueteSelect<T extends PaqueteDestino>({
  paquetes,
  value,
  onPick,
  testId,
}: {
  paquetes: T[]
  value: T | null
  onPick: (paquete: T | null) => void
  testId: string
}) {
  const {t} = useTranslation()
  const etiqueta = (p: T) => `${p.employee_name} · ${t('admin.bateria.formaValue', {forma: p.forma})}`
  return (
    <EntitySearchSelect
      items={paquetes}
      value={value}
      getKey={(p) => p.id}
      filterText={(p) => `${p.employee_name} ${p.forma}`}
      renderOption={etiqueta}
      renderTriggerValue={etiqueta}
      placeholder={t('admin.bateria.cuarentena.paquetePlaceholder')}
      searchPlaceholder={t('admin.bateria.cuarentena.paqueteSearchPlaceholder')}
      noResultsLabel={t('admin.bateria.cuarentena.paqueteNoResults')}
      testId={testId}
      onPick={onPick}
    />
  )
}
